import { useEffect } from 'react';

export function useHeightWatcher(target, property) {
    useEffect(() => {
        if (!target.current) return;
        const observer = new ResizeObserver((entries) => {
            const height = entries[0].target.offsetHeight;

            document.documentElement.style.setProperty(
                `--${property}`,
                `${height}px`
            );
        });
        observer.observe(target.current);
        return () => {
            document.documentElement.style.setProperty(
                `--${property}`,
                `${0}px`
            );
            observer.disconnect();
        };
    }, [target.current]);
}
